import { ResolveResource, Extractor } from './utils'
import Factory from './utils/Factory'
import graphql from '@/api/graphql'
import Mutations from '@/api/graphql/mutations'
const resource = ResolveResource(__filename)
import router from '@/router'

import fetch from '@/fetch'

export default new Factory(resource, {
  mutate(rawPayload = {}, options = {}) {
    let { mutation = getAction(rawPayload), transformPayload = true, draft } = options
    let payload = getPayload(rawPayload)

    return graphql
      .request(Mutations[mutation], payload, draft)
      .then(Extractor)
      .then(res => {
        if (res instanceof Array) return res.map(r => ({ ...payload.data, ...r }))
        return { ...payload.data, ...res }
      })

    function getPayload(x) {
      if (!transformPayload) return x
      let { id, quantity, ...data } = x
      return { id, quantity, data }
    }

    function getAction(x) {
      if (x.quantity) return 'ResidentialsCreate'
      if (x.id) return 'ResidentialUpdate'
      return 'ResidentialCreate'
    }
  },

  validateNumber(payload = {}, options = {}) {
    let { draft } = options

    let params = new URLSearchParams(Object.entries(payload))
    return fetch('/api/residential/validate/number?' + params.toString(), {
      headers: {
        'kvass-draft': draft,
      },
    })
  },

  validateCadastre(payload = {}, options = {}) {
    let { draft } = options

    let params = new URLSearchParams(Object.entries(payload))
    return fetch('/api/residential/validate/cadastre?' + params.toString(), {
      headers: {
        'kvass-draft': draft,
      },
    })
  },
})
